module.exports = __webpack_public_path__ + "components/app-promo/static/play-store_badge--black-608e487145e6583775ee898103e0b129.svg";